Application.Signature.Color.Transformer = {
    ui: {
        container: '.step-color__preview .preview',
        icon: '.step-preview__preview-icon',
        transformer: '.preview__color-transform',
        transformerImg: '.preview__color-transform-img',
        ui: '.img-transform__ui',
        move: '.img-transform__move',
        resize: '.img-transform__resize',
        rotate: '.img-transform__rotate',
        open: '.preview__edit',
        save: '.preview__save'
    },
    handlers: {
        move: [],
        resize: [],
        rotate: [],
        stop: []
    },
    color: null,
    scale: 1,
    ready: function (color) {

        this.color = color;

        // bind
        this.bind();
        // init
        this.repositionHandles(0);

        // auto start
        this.start();

    },
    bind: function(){

        var self = this;

        // open editor
        $(document).on('click', this.ui.open, function(event){
            event.preventDefault();
            self.start();
        });

        // close editor
        $(document).on('click', this.ui.save, function(event){
            event.preventDefault();
            self.stop();
        });

        // move
        $(document).on('mousedown', this.ui.move, self.onMoveStart.bind(this));
        $(document).on('touchstart', this.ui.move, self.onMoveStart.bind(this));

        // resize
        $(document).on('mousedown', this.ui.resize, self.onResizeStart.bind(this));
        $(document).on('touchstart', this.ui.resize, self.onResizeStart.bind(this));

        // rotate
        $(document).on('mousedown', this.ui.rotate, self.onRotateStart.bind(this));
        $(document).on('touchstart', this.ui.rotate, self.onRotateStart.bind(this));

    },
    onMoveStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // handlers
        var move = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.move((x - x1) / self.scale, (y - y1) / self.scale);
            // update state
            x = x1;
            y = y1;
        };
        var moveEnd = function(){
            $(document).off('mousemove', move);
            $(document).off('touchmove', move);
            $(document).off('mouseup', moveEnd);
            $(document).off('touchend', moveEnd);
        };

        // bind
        $(document).on('mousemove', move);
        $(document).on('touchmove', move);
        $(document).on('mouseup', moveEnd);
        $(document).on('touchend', moveEnd);

    },
    onResizeStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // direction
        var direction = $(event.target).data('direction');

        // handlers
        var resize = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.resize(direction, (x - x1) / self.scale, (y - y1) / self.scale);
        };
        var resizeEnd = function(){
            $(document).off('mousemove', resize);
            $(document).off('touchmove', resize);
            $(document).off('mouseup', resizeEnd);
            $(document).off('touchend', resizeEnd);
            // commit
            self.resizeCommit()
        };

        // bind
        $(document).on('mousemove', resize);
        $(document).on('touchmove', resize);
        $(document).on('mouseup', resizeEnd);
        $(document).on('touchend', resizeEnd);

    },
    onRotateStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // direction
        var direction = $(event.target).data('direction');

        // handlers
        var rotate = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.rotate(x, y, x1, y1);
            // update state
            x = x1;
            y = y1;
        };
        var rotateEnd = function(){
            $(document).off('mousemove', rotate);
            $(document).off('touchmove', rotate);
            $(document).off('mouseup', rotateEnd);
            $(document).off('touchend', rotateEnd);
        };

        // bind
        $(document).on('mousemove', rotate);
        $(document).on('touchmove', rotate);
        $(document).on('mouseup', rotateEnd);
        $(document).on('touchend', rotateEnd);

    },
    start: function(){

        // change state
        $(this.ui.container).addClass('preview_editing');

    },
    stop: function(){

        // change state
        $(this.ui.container).removeClass('preview_editing');

        // handlers
        this.trigger('stop');

    },
    setBackground: function(src){

        var $img = $('<img>').attr('src', src);

        // change state
        $(this.ui.transformerImg).empty().append($img);

    },
    move: function(x, y){

        // elements
        var $icon = $(this.ui.icon);
        var $transformer = $(this.ui.transformer);

        // retrieve current values
        var left = parseFloat($transformer.css('left'));
        var top = parseFloat($transformer.css('top'));
        var width = $transformer.width();
        var height = $transformer.height();
        var iconWidth = $icon.width();
        var iconHeight = $icon.height();

        // do not allow to pass the edge values
        var newX = left - x;
        newX = newX > 0 ? 0 : newX;
        newX = newX + width < iconWidth ? iconWidth - width : newX;
        var newY = top - y;
        newY = newY > 0 ? 0 : newY;
        newY = newY + height < iconHeight ? iconHeight - height : newY;

        // update
        $(this.ui.transformer).css({
            left: newX + 'px',
            top: newY + 'px'
        });

        // handlers
        this.trigger('move', [newX, newY]);

    },
    resize: function(direction, x, y){

        // elements
        var $icon = $(this.ui.icon);
        var $transformer = $(this.ui.transformer);

        // set base values
        if (!$transformer.data('resize-base-initiated')){
            $transformer.data('resize-base-initiated', true);
            $transformer.data('resize-base-x', parseFloat($transformer.css('left')));
            $transformer.data('resize-base-y', parseFloat($transformer.css('top')));
            $transformer.data('resize-base-w', $transformer.width());
            $transformer.data('resize-base-h', $transformer.height());
        }
        // retrieve base values
        var left = $transformer.data('resize-base-x');
        var top = $transformer.data('resize-base-y');
        var width = $transformer.data('resize-base-w');
        var height = $transformer.data('resize-base-h');
        var iconWidth = $icon.width();
        var iconHeight = $icon.height();

        // resize based ond the direction
        switch (direction){
            case 'br':
                var newW = width - x;
                var newH = height - y;
                break;
            case 'b':
                var newH = height - y;
                var newW = newH * width / height;
                break;
            case 'bl':
                var newW = width + x;
                var newH = height - y;
                break;
            case 'r':
                var newW = width - x;
                var newH = newW * height / width;
                break;
            case 'l':
                var newW = width + x;
                var newH = newW * height / width;
                break;
            case 'tr':
                var newW = width - x;
                var newH = height + y;
                break;
            case 't':
                var newH = height + y;
                var newW = newH * width / height;
                break;
            case 'tl':
                var newW = width + x;
                var newH = height + y;
                break;
        }

        // min and max sizes
        newW = newW < iconWidth ? iconWidth: newW;
        newW = newW > 500 ? 500: newW;
        newH = newH < iconHeight ? iconHeight: newH;
        newH = newH > 500 ? 500: newH;

        // preserve aspect ratio
        var ar = width / height;
        if (ar > newW / newH){
            newW = ar * newH;
        }else{
            newH = newW / ar;
        }

        // reposition based ond the direction
        switch (direction){
            case 'br':
                var newX = left;
                var newY = top;
                break;
            case 'b':
                var newX = left;
                var newY = top;
                break;
            case 'bl':
                var newX = left - (newW - width);
                var newY = top;
                break;
            case 'r':
                var newX = left;
                var newY = top;
                break;
            case 'l':
                var newX = left - (newW - width);
                var newY = top;
                break;
            case 'tr':
                var newX = left;
                var newY = top - (newH - height);
                break;
            case 't':
                var newX = left;
                var newY = top - (newH - height);
                break;
            case 'tl':
                var newX = left - (newW - width);
                var newY = top - (newH - height);
                break;
        }

        // do not allow to pass the edge values
        newX = newX > 0 ? 0 : newX;
        newX = newX + newW < iconWidth ? iconWidth - newW : newX;
        newY = newY > 0 ? 0 : newY;
        newY = newY + newH < iconHeight ? iconHeight - newH : newY;

        // update
        $(this.ui.transformer).css({
            left: newX + 'px',
            top: newY + 'px',
            width: newW + 'px',
            height: newH + 'px',
        });

        // handlers
        this.trigger('resize', [newX, newY, newW, newH]);

    },
    resizeCommit: function(){

        var $transformer = $(this.ui.transformer);

        $transformer.data('resize-base-initiated', false);
        $transformer.data('resize-base-x', null);
        $transformer.data('resize-base-y', null);
        $transformer.data('resize-base-w', null);
        $transformer.data('resize-base-h', null);

    },
    rotate: function(x, y, x1, y1){

        // find transformer center as the transform origin
        var $transformer = $(this.ui.transformer);
        var cx = $transformer.offset().left + $transformer.width() / 2;
        var cy = $transformer.offset().top + $transformer.height() / 2;

        // calculate the rotation degree
        var a1 = Math.atan2(y - cy, x - cx);
        var a2 = Math.atan2(y1 - cy, x1 - cx);
        var a = a2 - a1;

        var current = $(this.ui.transformer).data('rotate-angle') ? $(this.ui.transformer).data('rotate-angle') : 0;
        var next = current + a;

        // update
        this.setRotation(next);

    },
    setPosition: function(x, y, width, height){

        $(this.ui.transformer).css({
            left: x + 'px',
            top: y + 'px',
            width: width + 'px',
            height: height + 'px'
        });

    },
    setRotation: function(a){

        $(this.ui.transformer).css({
            transform: 'rotate(' + a + 'rad)'
        });
        $(this.ui.transformer).data('rotate-angle', a);

        // handlers
        this.trigger('rotate', [a]);

        // reposition
        this.repositionHandles(a);

    },
    repositionHandles: function(a){

        // convert
        var deg = a * 180 / Math.PI;
        // and normalize
        deg = deg % 360;
        deg = deg < 0 ? 360 + deg : deg;

        var angle = Math.floor(deg / 30) * 30;
        $(this.ui.ui).attr('data-rotation', angle);

    },
    setScale: function(scale){

        this.scale = scale;

    },
    on: function(event, callback){

        if (typeof this.handlers[event] !== 'undefined'){
            this.handlers[event].push(callback);
        }

    },
    trigger: function(event, args){

        if (typeof this.handlers[event] !== 'undefined'){
            for (var z in this.handlers[event]){
                if (!this.handlers[event].hasOwnProperty(z)){
                    continue;
                }
                this.handlers[event][z].apply(this, args);
            }
        }

    }
};